import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1928] px-4 py-5 text-center text-white/60" data-id="element-59" data-mp="32wd2qgad7ltj">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-white/80" data-id="element-60" data-mp="3ggaq1tbg494e">
        © 2026 AUTOMOTIVE DIAGNOSTIC PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-2 max-w-3xl text-[11px] font-medium leading-snug" data-id="element-61" data-mp="36pfufycb7x6a">
        AUTOMOTIVE DIAGNOSTIC PRO™ is a professional automotive diagnostic
        reference resource. It does not replace required training, manufacturer
        instructions, workplace safety procedures or qualified professional
        judgment.
      </p>
      <p className="mt-2 text-[11px] font-medium" data-id="element-62" data-mp="3ldaphldsidmj">
        Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="font-mono text-cyan underline decoration-cyan/40" data-id="element-63" data-mp="3qblxdqkiye24">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}